import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/Header/magnetix.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-col footer-brand">
          <Link to="/" className="footer-logo-link">
            <img src={logo} alt="Magnetix Logo" className="footer-logo-image" />
            <span className="footer-logo-text">Magnetix</span>
          </Link>
          <p className="footer-tagline">
            The learning platform that connects every training hour to a real
            business outcome. A MultipliersKraft product.
          </p>
        </div>

        <div className="footer-col">
          <h3 className="footer-column-title">COMPANY</h3>
          <ul className="footer-links">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-column-title">CONTACT</h3>
          <ul className="footer-links">
            <li><a href="tel:+919611058522" className="footer-link">+91-9611058522</a></li>
            <li><a href="mailto:support.magnetix@multiplierskraft.com" className="footer-link">support.magnetix@multiplierskraft.com</a></li>
            <li><span className="footer-link footer-address">Bangalore, India</span></li>
          </ul>
        </div>
      </div>

      <div className="footer-divider" />

      <div className="footer-copyright">
        <p>© 2025 Magnetix. A <a href="https://multiplierskraft.com" target="_blank" rel="noopener noreferrer" className="footer-copyright-link">MultipliersKraft</a> product.</p>
      </div>
    </footer>
  );
};

export default Footer;
